export const STORAGE_KEY = "cart-storage-v2";
export const FREE_SHIPPING_THRESHOLD = 25;
